<template>
  <div class="credit-memos responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'creditMemos', label: 'Credit Memo' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "creditMemos",
  data() {
    return {
      listPageHeader,
      entity: Entities.CREDITMEMO,
    };
  },
  mounted: function () {
    this.setPageTitle("CreditMemo");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "creditMemoModule/sort",
      pagination: "creditMemoModule/pagination",
      initialFilter: "creditMemoModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "creditMemoModule/updateSort",
      updatePagination: "creditMemoModule/updatePagination",
      updateInitialFilter: "creditMemoModule/updateInitialFilter"
    }),
  }
};
</script>
